import React from 'react';
import { Section } from './ui/Section';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
export function FinalCTA() {
  return <Section background="charcoal" className="text-center py-32" data-id="element-128">
      <div className="max-w-3xl mx-auto" data-id="element-129">
        <FadeIn data-id="element-130">
          <h2 className="text-5xl md:text-6xl font-serif text-ivory mb-8" data-id="element-131">
            Join the Next Era of Wellness
          </h2>
          <p className="text-xl text-ivory/70 mb-12 font-light" data-id="element-132">
            Whether you are seeking care, providing care, or investing in the
            future of care — there is a place for you here.
          </p>
        </FadeIn>

        <FadeIn delay={200} className="flex flex-col sm:flex-row items-center justify-center gap-4 md:gap-6" data-id="element-133">
          <a href="/practitioners" data-id="element-134">
            <Button variant="primary" size="lg" className="w-full sm:w-auto bg-purple-600 text-white hover:bg-purple-700" data-id="element-135">
              Join the Platform
            </Button>
          </a>
          <a href="/practitioners" data-id="element-136">
            <Button variant="outline" size="lg" className="w-full sm:w-auto border-ivory text-ivory hover:bg-ivory hover:text-charcoal" data-id="element-137">
              Apply to Network
            </Button>
          </a>
        </FadeIn>
      </div>
    </Section>;
}